export enum FeatureFlag {
  IS_DEVIATION_DETAILS_PAGE_ENABLED = 'IS_DEVIATION_DETAILS_PAGE_ENABLED',
  IS_USERCENTRICS_UI_ENABLED = 'IS_USERCENTRICS_UI_ENABLED',
  NEW_WEEK_STATUSES = 'NEW_WEEK_STATUSES',
  PRO_TALENT_IS_ASSIGNMENT_MANAGEMENT_ENABLED = 'PRO_TALENT_IS_ASSIGNMENT_MANAGEMENT_ENABLED',
  PRO_TALENT_IS_GEOLOCATION_ENABLED = 'PRO_TALENT_IS_GEOLOCATION_ENABLED',
  PRO_TALENT_IS_HIGH_ACCURACY_ENABLED = 'PRO_TALENT_IS_HIGH_ACCURACY_ENABLED',
  PRO_TALENT_TEST_USERS = 'PRO_TALENT_TEST_USERS',
  PRO_TALENT_IS_PUSH_ENABLED = 'PRO_TALENT_IS_PUSH_ENABLED',
  PRO_TALENT_IS_CV_BUILDER_ENABLED = 'PRO_TALENT_IS_CV_BUILDER_ENABLED'
}
